import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';

import * as vars from '../../constants/constants';
import { messages } from '../../constants/messages';
import { movies } from '../../constants/movies';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { getVideoOrChannelRelatedData } from '../../actions/PlayActions';
import { addFavoriteChannel, addFavoriteVideo } from '../../actions/FavoriteActions';
import { showMessage } from '../../actions/FlashMessageActions';
import { console_log, parseQueryString } from '../../utils/helper';
import { FormattedMessage } from 'react-intl';
import { config } from '../../constants/domainConfig';



class ShowList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            channels: [],
            videos: [],
            type: '',
            pageId: 0,
            categoryName: "",
            switchToFavourite: false
        };

        this.goToPlay = this.goToPlay.bind(this);
        this.videoFavorite = this.videoFavorite.bind(this);
        this.isVideoFavorite = this.isVideoFavorite.bind(this);
        this.showFavorite = this.showFavorite.bind(this);
    }

    componentWillMount() {
        let pageId = parseInt(this.props.history.location.pathname.split('/')[2]);
        if (pageId == 0) {
            this.setState({
                videos: [].concat.apply([], movies.map((c) => c.videos)),
                type: 'videos',
                pageId: pageId,
                categoryName: "Recently added"
            });
        } else {
            let category = movies.find((v) => v.id == pageId),
                videoByCategory = category['videos'];

            this.setState({
                videos: videoByCategory,
                type: 'videos',
                pageId: pageId,
                categoryName: category.name
            });
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    goToPlay(data, event) {
        event.preventDefault();
        if (event.target.tagName == 'path' || event.target.classList.contains('favoriteClick')) {
            this.videoFavorite(data.video);
        } else {
            this.props.getVideoOrChannelRelatedData(data);
            this.props.history.push('/show');
        }
    }

    videoFavorite(data) {
        let favoriteVideos = this.props.favorite.videos;
        let indexOf = favoriteVideos.findIndex((f) => {
            return f.videoId == data.id;
        });
        let videoToBeUpdated = {
            videoId: data.id,
            duration: data.duration,
            name: data.name,
            preview: data.preview
        };

        if (indexOf == -1) {
            this.props.showMessage({
                message: messages[config.lang].addToFavorites,
                type: true
            });
            favoriteVideos.push(videoToBeUpdated);
            axios.post(vars.BASE_API_URL+"/favorites/videos", videoToBeUpdated)
                .then((response) => {
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        } else {
            this.props.showMessage({
                message: messages[config.lang].removeFromFavorites,
                type: false
            });
            favoriteVideos.splice(indexOf, 1);
            axios.delete(vars.BASE_API_URL+"/favorites/videos/"+videoToBeUpdated.videoId)
                .then((response) => {
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        }

        this.props.addFavoriteVideo(favoriteVideos);
    }

    isVideoFavorite(videoId) {
        let indexOf = this.props.favorite.videos.findIndex((f) => {
            return f.videoId == videoId;
        });

        if (indexOf != -1) {
            return true;
        }
        return false;
    }

    showFavorite() {
        this.setState({
            switchToFavourite: !this.state.switchToFavourite
        })
    }

	render() {
		const heartIcon = '<svg class="favoriteClick" xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewbox="0 0 70 70" preserveAspectRatio="none"><path d="M66.43 20.39c-.93-10.37-8.21-17.9-17.32-17.9a17.224 17.224 0 0 0-14.76 8.57 16.588 16.588 0 0 0-14.4-8.57c-9.11 0-16.39 7.52-17.33 17.9a18.807 18.807 0 0 0 .55 6.8 29.14 29.14 0 0 0 8.86 14.91l22.31 20.41L57.02 42.1a29.227 29.227 0 0 0 8.87-14.91 18.412 18.412 0 0 0 .54-6.8z" data-name="fave ico" class="heart-fill"/></svg>',
		hollowArrow = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="36.2px" height="34.4px" viewBox="0 0 52.1 67.8" style="enable-background:new 0 0 52.1 67.8;" xml:space="preserve"><path d="M0 67.8V0l52.1 33.9L0 67.8zM4 7.4v52.9l40.6-26.4L4 7.4z"></path></svg>';
        return (
			<section className="show-list py-0">
				<div className="category-head">
                    <h3 className="channel-title">{this.state.categoryName}</h3>
                    <div className="category-head__favorite">
                        <h3>
                            <FormattedMessage id="favorite"
                                defaultMessage="Favorite"
                            />
                        </h3>
                        <label className="switch">
                            <input type="checkbox" className="switch__checkbox" checked={this.state.switchToFavourite} onChange={this.showFavorite}/>
                            <span className="switch__slider round"></span>
                        </label>
                    </div>
                </div>
                {this.state.videos.length > 0 ?
                    <div className="shows__wrap">
                        {this.state.videos.map((m) => {
                            if (!this.state.switchToFavourite || this.isVideoFavorite(m.id)){
                                return (
                                    <div key={m.id} className="shows hover__data"  onClick={this.goToPlay.bind(this, {video: m})}>
                                        <img className="shows__thumb" src={m.preview} alt={m.name} />
                                        <div className="channels-thumb__fav">
                                            <input className="icon-toggle favoriteClick" id={m.id} type="checkbox" checked={this.isVideoFavorite(m.id)} onChange={() => {}} />
                                            <label className="icon-toggle-label favoriteClick" htmlFor={m.id} >
                                                <span className="favoriteClick"><i className="fa fa-star favoriteClick" aria-hidden="true"></i></span>
                                            </label>
                                        </div>
                                        <div className="hover__details">
                                            <div className="hover__container">
                                                <h3 className="hover__title">{m.name}</h3>
                                                <span className="hollow-arrow" dangerouslySetInnerHTML={{ __html: hollowArrow }} />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        })}
                    </div>
                    : <div className="no-favorites__pane"><p className="white-text-color text-align-center"><strong>
                        <FormattedMessage id="noVidsFound"
                            defaultMessage="No Videos found."
                        /></strong></p></div>
                }
			</section>
		)
	}
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        getVideoOrChannelRelatedData,
        addFavoriteChannel,
        addFavoriteVideo,
        showMessage
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowList);


// WEBPACK FOOTER //
// ./src/components/ShowList/ShowList.js